// Do not edit.
import { ShaderStore } from "core/Engines/shaderStore";

const name = "aerialPerspectivePixelShader";
const shader = `#define RENDER_CAMERA_VOLUME
#include<atmosphereUboDeclaration>
var transmittanceLutSampler: sampler;
var transmittanceLut: texture_2d<f32>;
var multiScatteringLutSampler: sampler;
var multiScatteringLut: texture_2d<f32>;
#include<helperFunctions>
#include<atmosphereFunctions>
varying positionOnNearPlane: vec3f;
uniform layerIdx: f32;
@fragment
fn main(input: FragmentInputs)->FragmentOutputs {fragmentOutputs.color=renderCameraVolume(
input.positionOnNearPlane,
uniforms.layerIdx,
transmittanceLut,
multiScatteringLut
);}
`;
// Sideeffect
if (!ShaderStore.ShadersStoreWGSL[name]) {
    ShaderStore.ShadersStoreWGSL[name] = shader;
}
ShaderStore._PendingIncludesLoaders.push(() => Promise.all([
    import("../ShadersWGSL/ShadersInclude/atmosphereUboDeclaration"),
    import("core/ShadersWGSL/ShadersInclude/helperFunctions"),
    import("../ShadersWGSL/ShadersInclude/atmosphereFunctions")
]));
/** @internal */
export const aerialPerspectivePixelShaderWGSL = { name, shader };
